export const selectPosts = (state) => state.posts.posts;
export const selectSearchItems = (state) => state.posts.searchItems;
export const selectPostsFilters = (state) => state.posts.posts.filter;
export const selectUnpublishedFilterValue = (state) => state.posts.posts.filter.published === 'false';
export const selectTotalPosts = (state) => state.posts.posts.total;
